module.exports = __webpack_public_path__ + "static/media/br.8bcede61.svg";